import { useGlobalAudio } from '../../context/GlobalAudioContext';
import SpeakingLogo from './SpeakingLogo';

/**
 * SpeakingOverlay — affiche le logo Cabaza parlant pendant qu'un audio joue.
 * Position : floating bottom-right (assistant virtuel pour FAQ / Q&A libre).
 * Pour les tutoriels/nudges, le logo est ancré à la bulle directement (voir TutorialOverlay).
 */
const SpeakingOverlay = () => {
    const { isPlaying, anchor } = useGlobalAudio();

    // Cet overlay ne gère que le mode 'bottom-right'.
    // Les autres ancres (ex. bulle tutoriel) rendent SpeakingLogo inline.
    if (!isPlaying || anchor !== 'bottom-right') return null;

    return (
        <div
            style={{
                position: 'fixed',
                bottom: 24,
                right: 24,
                zIndex: 99998,
                pointerEvents: 'none'
            }}
        >
            <SpeakingLogo size={72} isSpeaking={true} />
        </div>
    );
};

export default SpeakingOverlay;
